import React from 'react'
import { NavLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import lvbt from './assets/lvbt.png'
import y from './assets/yShaped.gif'
import lenth from './assets/lenth.jpg'
import minBst from './assets/minBst.jpg'
import delBst from './assets/delBst.jpg'
import bst from './assets/bst.png'
import loopLL from './assets/loopLL.jpg'
import rb from './assets/rb.png'
import subAr from './assets/subAr.jpg'
import sb from './assets/sb.png'
import primera from './assets/primera.png'
import sm from './assets/sm.jpg'
const Ind = () => {
    return (
        <div>
               <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={lenth}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Find length of Loop</p>
      <NavLink to='/category/Qualcomm Interview question 1'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  

  
  <div class="card 1">
    <div class="card_image">
      <img src={minBst} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Min distance between two given nodes of a Binary Tree</p>
        <NavLink to='/category/Qualcomm Interview question 3'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
  
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={delBst} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Delete a node from BST</p>
      <NavLink to='/category/Qualcomm Interview question 4'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={lvbt} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Left View of Binary Tree</p>
      <NavLink to='/category/Qualcomm Interview question 5'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={y} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Intersection Point in Y Shapped Linked Lists</p>
        <NavLink to='/category/Qualcomm Interview question 6'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={bst} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Check for BST</p>
      <NavLink to='/category/Qualcomm Interview question 7'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
   
  
    <div class="card 4">
    <div class="card_image">
      <img src={loopLL} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Detect Loop in linked list</p>
      <NavLink to='/category/Qualcomm Interview question 9'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={rb} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Reverse Bits</p>
        <NavLink to='/category/Qualcomm Interview question 11'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
   
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={subAr} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Array Subset of another array</p>
      <NavLink to='/category/Qualcomm Interview question 12'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={sb}/>
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Set Bits</p>
      <NavLink to='/category/Qualcomm Interview question 13'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={primera} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Find Prime numbers in a range</p>
        <NavLink to='/category/Qualcomm Interview question 14'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={sm} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Subsequence matching</p>
      <NavLink to='/category/Qualcomm Interview question 15'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
       </div>  

    )
}

export default Ind
